import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ArrowRight, Users, Heart } from 'lucide-react';
interface Props {
  onNext: () => void;
}
const reactions = [{
  sentiment: 'Inspired',
  percent: 78,
  color: 'bg-green-500'
}, {
  sentiment: 'Energized',
  percent: 65,
  color: 'bg-blue-500'
}, {
  sentiment: 'Connected',
  percent: 82,
  color: 'bg-purple-500'
}];
export const PostScreen5Reactions = ({
  onNext
}: Props) => {
  const [revealed, setRevealed] = useState(false);
  useEffect(() => {
    const t = setTimeout(() => setRevealed(true), 800);
    return () => clearTimeout(t);
  }, []);
  return <div className="relative w-full h-full bg-slate-950 overflow-hidden flex flex-col" data-id="element-111">
      <div className="absolute inset-0 bg-gradient-to-b from-slate-900 via-slate-950 to-slate-950" data-id="element-112" />

      <div className="relative z-10 flex-1 flex flex-col p-8 pt-16" data-id="element-113">
        <motion.span initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} className="text-[10px] tracking-[0.3em] uppercase text-green-500 font-semibold mb-4" data-id="element-114">
          04 — Team Sentiment
        </motion.span>

        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} className="text-2xl font-bold text-white leading-tight mb-3" data-id="element-115">
          How the team felt at ERA
        </motion.h2>

        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 0.2
      }} className="flex items-center space-x-2 mb-8" data-id="element-116">
          <Users className="w-4 h-4 text-slate-500" data-id="element-117" />
          <span className="text-xs text-slate-500" data-id="element-118">Based on 127 responses</span>
        </motion.div>

        <div className="space-y-4 flex-1" data-id="element-119">
          {reactions.map((reaction, i) => <motion.div key={reaction.sentiment} initial={{
          opacity: 0,
          x: -20
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          delay: 0.3 + i * 0.15
        }} className="relative bg-slate-900/80 border border-slate-800 rounded-2xl p-4 overflow-hidden" data-id="element-120">
              <AnimatePresence data-id="element-121">
                {revealed && <motion.div initial={{
              width: 0
            }} animate={{
              width: `${reaction.percent}%`
            }} transition={{
              duration: 1,
              ease: 'easeOut',
              delay: i * 0.2
            }} className={`absolute inset-y-0 left-0 ${reaction.color} opacity-20`} data-id="element-122" />}
              </AnimatePresence>
              <div className="relative z-10 flex justify-between items-center" data-id="element-123">
                <div className="flex items-center space-x-3" data-id="element-124">
                  <Heart className="w-5 h-5 text-slate-400" data-id="element-125" />
                  <span className="text-white font-medium" data-id="element-126">
                    {reaction.sentiment}
                  </span>
                </div>
                <AnimatePresence data-id="element-127">
                  {revealed && <motion.span initial={{
                opacity: 0,
                scale: 0.8
              }} animate={{
                opacity: 1,
                scale: 1
              }} transition={{
                delay: 0.8 + i * 0.2
              }} className="text-2xl font-bold text-white" data-id="element-128">
                      {reaction.percent}%
                    </motion.span>}
                </AnimatePresence>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 1.5
      }} className="mt-6" data-id="element-129">
          <button onClick={onNext} className="w-full bg-green-600 hover:bg-green-500 text-white font-semibold py-4 rounded-2xl flex items-center justify-center space-x-2 transition-all active:scale-[0.98]" data-id="element-130">
            <span data-id="element-131">Continue</span>
            <ArrowRight className="w-5 h-5" data-id="element-132" />
          </button>
        </motion.div>
      </div>
    </div>;
};